import { useRoute, useRouter } from 'vue-router';
import { useGlobalAEMState } from '~/logic/aem/global-aem-state';
 
export function useSideSheetOverlay () {
	const route = useRoute();
	const router = useRouter();
	const { pageProperties } = useGlobalAEMState();
	const hashValue = ref(route.hash);
	const isVisible = ref(false);

	const overlayContents = ref([
		...(pageProperties.value.overlayPageProperties?.overlayItems ?? []),
		...(pageProperties.value.globalSidesheetOverlayList ?? []),
	]);
	const overlayData = ref(null); // Store page data here

	const setOverlayID = (newHash) => {
		if (newHash) {
			router.replace({ hash: newHash });
		}
	};
 
	const removeOverlayID = () => {
		router.replace({ hash: '' });
	};
 
	const removeOverlayIdButKeepQuery = (queriesToKeep) => {
		const filteredQuery = Object.fromEntries(Object.entries(route.query).filter(
			([key]) => queriesToKeep.includes(key)
		));
		router.replace({
			query: {
				...filteredQuery,
			},
			hash: '',
		});
	};

	const getPageDataBasedOnHash = (hash) => {
		return overlayContents.value.find((item) => item.overlayID === hash);
	};
 
	watch(
		() => route.hash,
		(newHash) => {
			let hashArr = newHash.split('#');
			let changedHash = newHash;
			if (hashArr.length - 1 > 1) {
				changedHash = `#${hashArr[1]}`;
			}
			const [value, queryString] = changedHash
				? (changedHash.includes('?') ? changedHash.split('?') : [changedHash, ''])
				: ['', '']; // handle the book flight widget
			hashValue.value = value;
			if (newHash) {
				overlayData.value = getPageDataBasedOnHash(hashValue.value);
				isVisible.value = !!overlayData.value;
			} else {
				overlayData.value = null;
				isVisible.value = false;
			}
		},
		{ immediate: true }
	);
 

	return {
		hashValue,
		overlayData,
		isVisible,
		setOverlayID,
		removeOverlayID,
		removeOverlayIdButKeepQuery,
	};
}